// John Eldhose 20180529
import React, { Component } from 'react';
import  { Redirect } from 'react-router-dom';
import { Button, Dialog, DialogTitle, Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { ManageAccountADT } from '../../Api/ManageAccountADT';
import { ManageAccountPP } from '../../Api/ManageAccountPP';
import { getAccount } from '../../Api/getAccount';

class ManageAccount extends Component {

  state = {
    ManageAccountADT: {},
    ManageAccountPPdata: [],
    ManageAccountRMA: false,
    ManageAccountCom: {},
    redirect: ''
  };
  componentWillMount() {
    ManageAccountADT()
      .then((acc) => {
        if(acc['status'] === 'true')
          this.setState({ ManageAccountADT: acc['data'] });
        else
          this.setState({ ManageAccountADT: {
            FIRSTNAME: 'Permission denied',
            ADDRESS1: 'Please contact your account administration or Carlson representative for access.'
          } });
      })
      .catch((error) => {
        console.log(error);
      })
    ManageAccountPP()
      .then((pp) => {
        if(pp['status'] === 'true')
          this.setState({ ManageAccountPPdata: pp['data'] })
        })
        .catch((error) => {
          console.log(error);
        })
    getAccount()
      .then((com) => {
        if(com['status'] === 'true')
          this.setState({ ManageAccountCom: com['data'] });
      })
      .catch((error) => {
        console.log(error);
      })
  }
  handleClickManageAccountADT = () => {
    this.setState({ redirect: '/accountdetailsteam' });
  }
  handleClickManageAccountPP = () => {
    this.setState({ redirect: '/productsplans' });
  }
  handleClickManageAccountRMA = (rma) => {
    this.setState({ redirect: rma, ManageAccountRMA: false });
  }
  handleClickManageAccountCom = () => {
    this.setState({ redirect: '/communications' });
  }

  render() {
    if(this.state.redirect === '')
      return (
        <div>
          <Typography variant='display1'>
            <center><font color='#385687'>
              <FormattedMessage
                id='Manage Account'
                defaultMessage='Manage Account'
              />
            </font></center>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={6} style={{ padding: '10px' }}>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickManageAccountADT}
              >
                <div className='ManageAccountItem'>
                  <Typography variant="title">
                    <img src='Carlson People Gear.ico' width='24' height='24' alt='Account' />&nbsp;
                    <FormattedMessage
                      id='Account Details & Users'
                      defaultMessage='Account Details & Users'
                    />
                  </Typography>
                  <p />
                  <div className='ManageAccountItemContent'>
                    <b>
                      {this.state.ManageAccountADT['FIRSTNAME']}&nbsp;
                      {this.state.ManageAccountADT['LASTNAME']}<br />
                    </b>
                    {this.state.ManageAccountADT['ADDRESS1']}<br />
                    {this.state.ManageAccountADT['ADDRESS2']}<br />
                    {this.state.ManageAccountADT['CITY']} &nbsp;
                    {this.state.ManageAccountADT['STATE']} &nbsp;
                    {this.state.ManageAccountADT['POSTALCODE']}<br />
                    {this.state.ManageAccountADT['WORKPHONE']}<br />
                    {this.state.ManageAccountADT['EMAIL']}<br />
                  </div>
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ padding: '10px' }}>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickManageAccountPP}
              >
                <div className='ManageAccountItem'>
                  <Typography variant="title">
                    <img src='Products.ico' width='24' height='24' alt='Account' />&nbsp;
                    <FormattedMessage
                      id='Products & Plans'
                      defaultMessage='Products & Plans'
                    />
                  </Typography>
                  <p />
                  <div className='ManageAccountItemContent'>
                    <FormattedMessage
                      id='My Carlson Products'
                      defaultMessage='My Carlson Products'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountPPdata['products']}
                    </span><br />
                    <FormattedMessage
                      id='Next Renewal'
                      defaultMessage='Next Renewal'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountPPdata['renewal']}
                    </span><br />
                    <FormattedMessage
                      id='Expired Plans'
                      defaultMessage='Expired Plans'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountPPdata['expired']}
                    </span><br />
                  </div>
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ padding: '10px' }}>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={() => this.setState({ ManageAccountRMA: true })}
              >
                <div className='ManageAccountItem'>
                  <Typography variant="title">
                    <img src='LMD.ico' width='24' height='24' alt='Account' />&nbsp;
                    <FormattedMessage
                      id='Return Material Authorization'
                      defaultMessage='Return Material Authorization'
                    />
                  </Typography>
                  <p />
                  <div className='ManageAccountItemContent'>
                    <FormattedMessage
                      id='View RMA status and create new RMAs'
                      defaultMessage='View RMA status and create new RMAs'
                    />
                  </div>
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ padding: '10px' }}>
              <Button
                fullWidth
                variant="outlined"
                style={{ textTransform: 'none' }}
                onClick={this.handleClickManageAccountCom}
              >
                <div className='ManageAccountItem'>
                  <Typography variant="title">
                    <img src='Communication.ico' width='24' height='24' alt='Account' />&nbsp;
                    <FormattedMessage
                      id='Communications'
                      defaultMessage='Communications'
                    />
                  </Typography>
                  <p />
                  <div className='ManageAccountItemContent'>
                    <FormattedMessage
                      id='Account Manager'
                      defaultMessage='Account Manager'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountCom['rep']}
                    </span><br />
                    <FormattedMessage
                      id='Phone Number'
                      defaultMessage='Phone Number'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountCom['repphone']}
                    </span><br />
                    <FormattedMessage
                      id='Carlson Dealer'
                      defaultMessage='Carlson Dealer'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountCom['dealer']}
                    </span><br />
                    <FormattedMessage
                      id='Phone Number'
                      defaultMessage='Phone Number'
                    />: <span style={{ color: 'gray' }}>
                      {this.state.ManageAccountCom['dealerphone']}
                    </span><br />
                    <center><b><FormattedMessage
                      id='Sign-up for Newsletter'
                      defaultMessage='Sign-up for Newsletter'
                    /></b></center>
                  </div>
                </div>
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} style={{ padding: '10px' }}>
              <div className='ManageAccountItem'>
                <Typography variant="title">
                  <img src='Tech Support.ico' width='24' height='24' alt='Account' />&nbsp;
                  <FormattedMessage
                    id='Technical Support'
                    defaultMessage='Technical Support'
                  />
                </Typography>
                <p />
                <div className='ManageAccountItemContent' style={{ border: '0px' }}>
                  <Typography variant="body1">
                    <FormattedMessage
                      id='Hours'
                      defaultMessage='Hours'
                    />:&nbsp;
                    <span style={{ color: 'gray' }}>
                    <FormattedMessage
                      id='Monday'
                      defaultMessage='Monday'
                    /> -
                    <FormattedMessage
                      id='Friday'
                      defaultMessage='Friday'
                    />: 8:00<sup>AM</sup> - 6:00<sup>PM</sup> (EST)<br />
                    </span>
                    <FormattedMessage
                      id='Telephone'
                      defaultMessage='Telephone'
                    />:&nbsp;
                    <span style={{ color: 'gray' }}>606 564 5028<br /></span>
                    <FormattedMessage
                      id='Email'
                      defaultMessage='Email'
                    />:&nbsp;
                    <span
                      style={{ color: 'gray' }}>support@carlsonsw.com
                    </span>
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
          <Dialog
            open={this.state.ManageAccountRMA}
            onClose={() => this.setState({ ManageAccountRMA: false })}
          >
            <DialogTitle>Return Material Authorization</DialogTitle>
            <div style={{ padding: '10px 50px 40px 30px' }}>
              <Button
                variant='raised'
                color='primary'
                onClick={() => this.handleClickManageAccountRMA('/rmas')}
              >
                Generic RMA
              </Button>
              <p />
              <Button
                variant='raised'
                color='primary'
                onClick={() => this.handleClickManageAccountRMA('/lmdrmas')}
              >
                Laser Measurement RMA
              </Button>
            </div>
          </Dialog>
        </div>
      );
    else
      return (<Redirect to={this.state.redirect} />);
  }
}

export default ManageAccount;



// WEBPACK FOOTER //
// ./src/components/home/ManageAccount.js